import { Entity } from "../helpers/Entity"

export type PaymentTermAttributes = {
    dueByDayOfMonth: number
    dueInNumberOfDays: number
    dueType: string
    isDefault: boolean
    minimumDaysToPay: number
    name: string
}

export type PaymentTermDto = {
    id: string
    type: string
    attributes: PaymentTermAttributes
}

export default class PaymentTerm implements Entity {
    private id: string
    private type: string
    private attributes: PaymentTermAttributes

    constructor(dto: PaymentTermDto) {
        this.id = dto.id
        this.type = dto.type
        this.attributes = dto.attributes
    }

    isLoaded() {
        return this.id != "" && this.type == "payment-terms"
    }

    getId() {
        return this.id
    }

    getName() {
        return this.attributes.name
    }
}



// WEBPACK FOOTER //
// ./src/state/payment-term/PaymentTerm.ts